import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const limitationLocaleModule: LocaleModule = {
  name: "limitation",
  messages: { en: en, it: it },
};
